<template>
  <form class="text-left" @submit.prevent @keydown.enter.prevent>
    <slot />
  </form>
</template>
